<div class="contenedor_spinner" [ngClass]="{ 'oculto': !cargandoTgrDetail }">
  <mat-spinner [diameter]="60"></mat-spinner>
</div>

<div [ngClass]="{ 'oculto': cargandoTgrDetail }">
  <div class="contenedor_btnExel">
    <button mat-raised-button color="primary" class="button_exel" (click)="exportToExcel()">Excel</button>
  </div>
  <table mat-table [dataSource]="dataSource" multiTemplateDataRows class="mat-elevation-z8">
  
    <ng-container matColumnDef="folio">
      <th mat-header-cell *matHeaderCellDef>Folio</th>
      <td mat-cell *matCellDef="let element">
        {{ element.folio }}
      </td>
    </ng-container>
  
    <ng-container matColumnDef="resolutionDate">
      <th mat-header-cell *matHeaderCellDef>Fecha Resolución</th>
      <td mat-cell *matCellDef="let element">
        {{ element.resolutionDate | date : "dd-MM-yyyy" }}
      </td>
    </ng-container>
  
    <ng-container matColumnDef="activationDate">
      <th mat-header-cell *matHeaderCellDef>Fecha Activacion</th>
      <td mat-cell *matCellDef="let element">
        {{ element.activationDate | date : "dd-MM-yyyy" }}
      </td>
    </ng-container>
  
    <ng-container matColumnDef="agreementType">
      <th mat-header-cell *matHeaderCellDef>Tipo Convenio</th>
      <td mat-cell *matCellDef="let element">
        {{ element.agreementType }}
      </td>
    </ng-container>

    <ng-container matColumnDef="totalAmountQuotes">
      <th mat-header-cell *matHeaderCellDef>Total</th>
      <td mat-cell *matCellDef="let element">
        {{ element.totalAmountQuotes | currency : "CLP" : "symbol" }}
      </td>
    </ng-container>
  
    <ng-container matColumnDef="quotesButton">
      <th mat-header-cell *matHeaderCellDef>Cuotas</th>
      <td mat-cell *matCellDef="let element">
        <button mat-raised-button color="primary" (click)="expandedElement = expandedElement === element ? null : element; $event.stopPropagation(); ocultarTabDebts()">Cuotas</button>
      </td>
    </ng-container>
  
    <ng-container matColumnDef="debtsButton">
      <th mat-header-cell *matHeaderCellDef>Deudas</th>
      <td mat-cell *matCellDef="let element">
        <button mat-raised-button color="primary" (click)="expandedElement = expandedElement === element ? null : element; $event.stopPropagation(); ocultarTabQuotas()">Deudas</button>
      </td>
    </ng-container>
  
    <ng-container matColumnDef="expandedDetail">
      <td mat-cell *matCellDef="let element" [attr.colspan]="columnsToDisplayWithExpand.length">
        <div class="example-element-detail" [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
          <div *ngIf="expandedElement === element" class="example-inner-detail expanded">
  
            <table mat-table [dataSource]="element.quotes" class="mat-elevation-z8 example-quotes-table" [ngClass]="{ 'oculto': ocultarQuotas }">
              <ng-container matColumnDef="dueDate">
                <th mat-header-cell *matHeaderCellDef> Fecha de Vencimiento </th>
                <td mat-cell *matCellDef="let quote"> {{ quote.dueDate | date : "dd-MM-yyyy" }} </td>
              </ng-container>
              <ng-container matColumnDef="amount">
                <th mat-header-cell *matHeaderCellDef> Monto </th>
                <td mat-cell *matCellDef="let quote"> {{ quote.amount | currency : "CLP" : "symbol" }} </td>
              </ng-container>
              <ng-container matColumnDef="quota">
                <th mat-header-cell *matHeaderCellDef> Cuota </th>
                <td mat-cell *matCellDef="let quote"> {{ quote.quota }} </td>
              </ng-container>
              <ng-container matColumnDef="paid">
                <th mat-header-cell *matHeaderCellDef> Pagado </th>
                <td mat-cell *matCellDef="let quote"> {{ quote.paid ? 'Sí' : 'No' }} </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="quoteColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: quoteColumns;"></tr>
            </table>
  
            <table mat-table [dataSource]="element.tgrDebtWithAgreement" class="mat-elevation-z8 example-quotes-table" [ngClass]="{ 'oculto': ocultarDebt }">
              <ng-container matColumnDef="debtType">
                <th mat-header-cell *matHeaderCellDef> Tipo Deuda </th>
                <td mat-cell *matCellDef="let tgrDebtWithAgreement"> {{ tgrDebtWithAgreement.debtType }} </td>
              </ng-container>
              <ng-container matColumnDef="form">
                <th mat-header-cell *matHeaderCellDef> Formulario </th>
                <td mat-cell *matCellDef="let tgrDebtWithAgreement"> {{ tgrDebtWithAgreement.form }} </td>
              </ng-container>
              <ng-container matColumnDef="folio">
                <th mat-header-cell *matHeaderCellDef> Folio </th>
                <td mat-cell *matCellDef="let tgrDebtWithAgreement"> {{ tgrDebtWithAgreement.folio }} </td>
              </ng-container>
              <ng-container matColumnDef="endDate">
                <th mat-header-cell *matHeaderCellDef> Vencimiento </th>
                <td mat-cell *matCellDef="let tgrDebtWithAgreement"> {{ tgrDebtWithAgreement.endDate | date : "dd-MM-yyyy" }} </td>
              </ng-container>
              <ng-container matColumnDef="condOtorgadaIntereses">
                <th mat-header-cell *matHeaderCellDef> Con.Intéreses </th>
                <td mat-cell *matCellDef="let tgrDebtWithAgreement"> {{ tgrDebtWithAgreement.condOtorgadaIntereses }} %</td>
              </ng-container>
              <ng-container matColumnDef="condOtorgadaMulta">
                <th mat-header-cell *matHeaderCellDef> Con.Multa </th>
                <td mat-cell *matCellDef="let tgrDebtWithAgreement"> {{ tgrDebtWithAgreement.condOtorgadaMulta }} %</td>
              </ng-container>
              <ng-container matColumnDef="totalAmountToPay">
                <th mat-header-cell *matHeaderCellDef> Total </th>
                <td mat-cell *matCellDef="let tgrDebtWithAgreement"> {{ tgrDebtWithAgreement.totalAmountToPay | currency : "CLP" : "symbol" }} </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="debtColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: debtColumns;"></tr>
            </table>
  
          </div>
        </div>
      </td>
    </ng-container>
  
    <tr mat-header-row *matHeaderRowDef="columnsToDisplayWithExpand"></tr>
    <tr mat-row *matRowDef="let element; columns: columnsToDisplayWithExpand;" class="example-element-row" [class.example-expanded-row]="expandedElement === element"></tr>
    <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
  </table>
</div>
